import IsLocalStorageAvil from './isLocalStorage';

const setCookie = (name: string, value: string, days: number, secure: boolean = false): void => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    let data = name + '=' + (value || '') + expires + '; ';
    if (secure) {
        data += 'SameSite=Lax; Secure; ';
    }
    data += 'path=/';
    document.cookie = data;
};

const getCookie = (name: string): string | null => {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

const eraseCookie = (name: string): void => {
    document.cookie = name + '=; Max-Age=-99999999;';
    try {
        document.cookie =
            name + `=;domain=.${window.location.hostname.split('.').slice(-2).join('.')}; Max-Age=-99999999;`;
    } catch (error) {}
};

const checkCookies = () => {
    let cookieEnabled = navigator.cookieEnabled;
    if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }
    return cookieEnabled;
};

const getMotoragazziCookies = () => {
    if (IsLocalStorageAvil()) {
        let c = window.localStorage.getItem('motoragazzi_cookies');
        if (c !== null) {
            return c;
        }
    }

    return '0';
};

export {setCookie, getCookie, eraseCookie, checkCookies, getMotoragazziCookies};
